import React from 'react'
import "../assets/static/copyright.css";

const Copyright = () => {
  return (
    <div className='copyright-page'>
        <p>© 2020 Apex CPD  Privacy policy</p>
      
    </div>
  )
}

export default Copyright
